import { BaseYcState, RegisterYCState } from '@yourcause/common/state';

@RegisterYCState()
export class ApplicationFormState extends BaseYcState {
  readonly editingForm: boolean;
  readonly formsForUser: string[];
  readonly optionalFormsForUser: string[];
}
